import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const SnookerIcon = observer('SnookerIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            className={className}
            onClick={onClick}
        >
            <mask
                id='snookerMask'
                width='14'
                height='13'
                x='1'
                y='1'
                maskUnits='userSpaceOnUse'
                style={{ maskType: 'alpha' }}
            >
                <path
                    fill='#142448'
                    d='M8 4.98c.687 0 1.207-.54 1.207-1.207a1.2 1.2 0 0 0-.138-.566c-.063-.123-.339-.662-1.07-.662-.69 0-.984.492-1.075.644q-.02.035-.027.043a1.1 1.1 0 0 0-.125.52c0 .667.562 1.229 1.228 1.229M7.77 6.25c0 .667-.52 1.208-1.206 1.208-.854 0-1.5-.875-1.062-1.77v-.02a1.209 1.209 0 0 1 2.269.582M8.208 6.25c0 .667.541 1.208 1.207 1.208.687 0 1.208-.541 1.208-1.208s-.541-1.207-1.208-1.207c-.645-.02-1.207.541-1.207 1.207M12.08 8.748a1.207 1.207 0 1 1-2.415 0 1.207 1.207 0 0 1 2.415 0M8 9.956A1.207 1.207 0 1 0 8 7.54a1.207 1.207 0 0 0 0 2.415M5.148 7.541a1.208 1.208 0 1 1-.002 2.417 1.208 1.208 0 0 1 .002-2.417M12.288 12.433a1.207 1.207 0 1 0 0-2.415 1.207 1.207 0 0 0 0 2.415M10.644 11.226a1.207 1.207 0 1 1-2.415 0 1.207 1.207 0 0 1 2.415 0M6.564 10.018a1.208 1.208 0 0 0 0 2.415c.687 0 1.207-.541 1.207-1.207.02-.667-.541-1.208-1.207-1.208M4.919 11.226a1.207 1.207 0 1 1-2.415 0 1.207 1.207 0 0 1 2.415 0'
                />
                <path
                    fill='#142448'
                    fillRule='evenodd'
                    d='M14.37 10.227 9.915 2.502A2.2 2.2 0 0 0 8 1.4c-.791 0-1.52.416-1.915 1.103L1.63 10.227a2.2 2.2 0 0 0 0 2.206 2.18 2.18 0 0 0 1.915 1.103h8.91c.79 0 1.52-.416 1.915-1.103.396-.708.396-1.52 0-2.206m-.562 1.873c-.292.5-.791.791-1.353.791h-8.91a1.55 1.55 0 0 1-1.353-.791 1.5 1.5 0 0 1 0-1.561l4.455-7.723c.291-.5.79-.791 1.353-.791s1.062.291 1.353.79l4.455 7.724c.27.479.27 1.061 0 1.561'
                    clipRule='evenodd'
                />
            </mask>
            <g mask='url(#snookerMask)'>
                <path
                    fill='#0b1627'
                    fillOpacity='.64'
                    d='M0 0h16v16H0z'
                />
            </g>
        </SvgElement>
    );
});
